import React from 'react';
import PropTypes from 'prop-types';

import FeatureToggle from '@stubhub/react-feature-toggle';
import {connect} from '@stubhub/react-store-provider';

import {isNewXoExperienceEnabledSelector} from '../../../../store/gsConfig/FF/selectors';
import FEATURE_FLAGS from '../../../../utils/featureFlags';

const mapStateToProps = (state) => {
  return {
    isNewXoEnabled: isNewXoExperienceEnabledSelector(state),
  };
};

export default function CheckoutIntegrationHoc(ReactComponent) {
  @connect({mapStateToProps})
  class WithComponent extends React.Component {
    render() {
      return (
        <FeatureToggle name={FEATURE_FLAGS.byo.newXoExperience}>
          {(on) => (
            <ReactComponent hrefPrefix={`/${on ? 'next-checkout/summary/' : 'checkout/review/'}`} {...this.props} />
          )}
        </FeatureToggle>
      );
    }
  }

  WithComponent.propTypes = {
    /* Whether the new checkout experience is enabled */
    isNewXoEnabled: PropTypes.bool,
  };

  WithComponent.displayName = 'CheckoutIntegrationHoc';

  return WithComponent;
}
